import React from "react";

import FallbackCheckedIcon from "../../../assets/layerlist/checked.svg?react";
import FallbackUncheckIcon from "../../../assets/layerlist/unchecked.svg?react";

import "./Checkbox.css";

interface CheckboxProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    checkedIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    uncheckedIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
    id,
    checked,
    onChange,
    checkedIcon: CheckedIcon,
    uncheckedIcon: UncheckedIcon,
    disabled,
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            if (!disabled) {
                onChange(!checked);
            }
        }
    };

    return (
        <div className={`custom-checkbox ${disabled ? "disabled" : ""}`}>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                className="custom-checkbox__input"
                disabled={disabled}
            />
            <label htmlFor={id} className={`custom-checkbox__label ${disabled ? "disabled" : ""}`}>
                {checked &&
                    (CheckedIcon ? (
                        <CheckedIcon className="custom-checkbox__icon" />
                    ) : (
                        <FallbackCheckedIcon className="custom-checkbox_icon" />
                    ))}
                {!checked &&
                    (UncheckedIcon ? (
                        <UncheckedIcon className="custom-checkbox__icon" />
                    ) : (
                        <FallbackUncheckIcon className="custom-checkbox_icon" />
                    ))}
            </label>
        </div>
    );
};

export default Checkbox;
